import { CbhIcon, Text, type TextProps } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";

interface WorkplaceNameWithDistanceProps {
  workplaceName: string;
  formattedDistance?: string;
  isFavoriteWorkplace?: boolean;
  textVariant?: TextProps["variant"];
  distanceTextVariant?: TextProps["variant"];
}

/**
 * Renders a workplace name with a map pin icon.
 */
export function WorkplaceNameWithDistance(props: WorkplaceNameWithDistanceProps) {
  const {
    workplaceName,
    textVariant = "body2",
    distanceTextVariant = "body2",
    formattedDistance,
    isFavoriteWorkplace,
  } = props;

  return (
    <Text
      variant={textVariant}
      sx={(theme) => ({
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: theme.palette.text.secondary,
        display: "flex",
        alignItems: "center",
        gap: 2,
      })}
    >
      {workplaceName}
      {isFavoriteWorkplace && (
        <CbhIcon data-testid="favorite-workplace-icon" type="like-filled" size="small" />
      )}
      {isDefined(formattedDistance) && (
        <Box
          component="span"
          sx={(theme) => ({
            color: theme.palette.text.tertiary,
            fontSize: theme.typography[distanceTextVariant].fontSize,
            lineHeight: theme.typography[distanceTextVariant].lineHeight,
          })}
        >
          {formattedDistance}
        </Box>
      )}
    </Text>
  );
}
